export const PEDIDO_VOO_STATUS_OPTIONS = [
  { id: 'AGUARDANDO_VALIDACAO', nome: 'Aguardando Aprovação' },
  { id: 'VALIDADO', nome: 'Aprovação' },
  { id: 'INVALIDADO', nome: 'Negado' },
];

export const PEDIDO_VOO_STATUS_FILTER_OPTIONS = PEDIDO_VOO_STATUS_OPTIONS.map(
  ({ id, nome }) => ({ value: id, label: nome })
);

export const getPedidoVooStatusLabel = (status) => {
  if (status === 'RESTRICAO_AREA') return 'Negado';
  const found = PEDIDO_VOO_STATUS_OPTIONS.find((o) => o.id === status);
  return found ? found.nome : status;
};

export const getCodigoPilotoSisant = (data) =>
  data?.codigoPilotoSisant ?? data?.codigoPilotoAnac ?? '';

export const hasPendingArquivoUpload = (arquivos) =>
  Array.isArray(arquivos) && arquivos.some((a) => a.new === true);
